import React from "react";
import * as Styles from "./styles/GradeEquipmentList";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { BnbLabel } from "../../../utils/labels";
import { trackEngineViewEquipmentWithGradeName } from "../../../utils/tracking";
import type { BuildAndBuyDispatchType } from "../../../redux/store";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_GRADE_EQUIPMENT } from "../../../utils/modalConstants";
import type { ModelGradeType, ModelType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useDispatch } from "../../../../../../shared-logic/redux/store";
import ButtonTertiary from "../../../../../../common-deprecated/components/aem/toyota/ButtonTertiary";
import { NavStep } from "../../../../shared-logic/utils/Navigation";

type GradeEquipmentListProps = {
    grade: ModelGradeType;
    model: ModelType;
};

export const GradeEquipmentList = ({ grade, model }: GradeEquipmentListProps): JSX.Element | null => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const equipmentList = grade.standardEquipment.filter((equipment) => equipment.feature).slice(0, 4);

    if (!equipmentList || equipmentList.length === 0) return null;
    return (
        <>
            <Styles.Title>
                <BnbLabel label="standardEquipment" />
            </Styles.Title>
            <Styles.List>
                {equipmentList.map((equipment) => (
                    <li key={equipment.id}>
                        {equipment.name}
                        {!!equipment.toolTip && <Type.Strong pl={1}>{equipment.toolTip}</Type.Strong>}
                    </li>
                ))}
            </Styles.List>
            {equipmentList.length > 0 && (
                <ButtonTertiary
                    onClick={() => {
                        trackEngineViewEquipmentWithGradeName(grade.name || model.name, NavStep.ModelEngine);
                        dispatch(
                            showModal({
                                type: MODAL_GRADE_EQUIPMENT,
                                gradeName: grade.name,
                                gradeSubtitle: grade.subtitle,
                                modelName: model.name,
                                mainFeatureEquipment: grade.standardEquipment,
                                listFeatureEquipment: grade.listEquipment,
                            }),
                        );
                    }}
                >
                    <BnbLabel label="showStandardEquipment" />
                </ButtonTertiary>
            )}
        </>
    );
};
